<template>
  <section class="sample-detail">
    <h2>회원 상세 · 샘플 데이터</h2>
    <template v-if="member">
      <table class="mainTable"><tbody>
        <tr v-for="field in fields" :key="field[0]"><th>{{ field[1] }}</th><td>{{ member[field[0]] }}</td></tr>
      </tbody></table>
      <p>조회 체험 화면입니다. 비밀번호·실제 개인정보는 없으며 지급·회수·회원 수정은 실행하지 않습니다.</p>
      <router-link :to="{ path: '/bet/list/all', query: { id: member.memId } }">이 회원 베팅내역 보기 →</router-link>
    </template>
    <p v-else>해당 샘플 회원을 찾을 수 없습니다.</p>
    <router-link to="/user/list">회원 목록으로</router-link>
  </section>
</template>
<script>
import { members } from './api.cjs'
export default {
  computed: { member () { return members.find(m => m.memId === (this.$route.query.id || members[0].memId)) } },
  data () { return { fields: [['memId', '아이디'], ['memNick', '닉네임'], ['memLevel', '회원 레벨'], ['cashAmt', '보유머니'], ['pointAmt', '보유 포인트'], ['recommenderNick', '상위 파트너'], ['regDt', '가입일'], ['lastLoginDt', '마지막 로그인'], ['memo', '메모']] } }
}
</script>
<style scoped>
.sample-detail { padding: 30px; color: #eef3fa; } h2 { font-size: 22px; margin-bottom: 24px; font-weight: 600; } th { width: 200px; } p { margin: 24px 0; } a { display: inline-block; padding: 12px 20px; margin: 15px 15px 0 0; background: #245743; border-radius: 5px; }
</style>
